import { type PropsWithChildren, Suspense } from 'react';
import { useRouter } from 'next/router';
import { web2app } from '@kcd/app-interface';
import { trackEvent } from '@kcd/event-tracker';

import LoadingSpinnerCenter from '~/components/LoadingSpinnerCenter';
import MarketNonLoginPopup from '~/components/MarketNonLoginPopup';
import { TrackPage } from '~/components/TrackEvent';
import { BRIDGE_ROUTER } from '~/constants/router';
import { useCurrentUser } from '~/domains/auth/queries';
import { MobileAppContextProvider } from '~/hooks/mobileApp';
import AppMarketHomeLink from '~/layouts/AppMarketHomeLink';
import BaseLayout from '~/layouts/BaseLayout';
import RightMenu from '~/layouts/RightMenu';

export function EventPageLayout({ children }: PropsWithChildren) {
  const { isLoggedIn, user } = useCurrentUser();
  const router = useRouter();

  const onLeftClick = async () => {
    trackEvent('viewed dialog in 마켓', {
      type: '이벤트페이지 이탈방어',
      path: window.location.pathname,
    });

    const { confirmed } = await web2app.openDialogAsync({
      title: `${user?.name || '사장'}님에게 \n꼭 맞는 상품이 있어요.`,
      description: '필요한 상품을 찾아보세요.',
      type: 'confirm',
      confirmText: '확인하기',
      cancelText: '나가기',
    });
    if (!confirmed) {
      web2app.closeCurrentModal();
      return;
    }

    void router.push(BRIDGE_ROUTER.storeRecommend);
  };

  return (
    <MobileAppContextProvider LinkComponent={AppMarketHomeLink}>
      <BaseLayout
        title="캐시노트 마켓 이벤트"
        right={<RightMenu />}
        onLeftClick={onLeftClick}
      >
        <TrackPage
          page="마켓/이벤트"
          properties={{
            userType: user?.isOrdered ? '재구매자' : '신규구매자',
          }}
        />
        <Suspense fallback={<LoadingSpinnerCenter />}>{children}</Suspense>

        {!isLoggedIn && <MarketNonLoginPopup />}
      </BaseLayout>
    </MobileAppContextProvider>
  );
}
